/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteFormFieldModal_formField$ref: FragmentReference;
declare export opaque type DeleteFormFieldModal_formField$fragmentType: DeleteFormFieldModal_formField$ref;
export type DeleteFormFieldModal_formField = {|
  +id: string,
  +name: string,
  +$refType: DeleteFormFieldModal_formField$ref,
|};
export type DeleteFormFieldModal_formField$data = DeleteFormFieldModal_formField;
export type DeleteFormFieldModal_formField$key = {
  +$data?: DeleteFormFieldModal_formField$data,
  +$fragmentRefs: DeleteFormFieldModal_formField$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteFormFieldModal_formField",
  "type": "FormField",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a7b215a136133c72303aa5d7c69c60e8';
module.exports = node;
